<script setup>
import { ref, onMounted, computed, inject, defineProps, watch } from "vue";
import { jsbridge, checkAppUserAgent } from "../utils";
const props = defineProps({
  categoryIndex: Number,
});

const { categoryList, curCategory, curFlycard } = inject("useDataHook");
const { playerStatus, playerInit, togglePlayerStatus, howlerList } = inject(
  "usePlayerHook"
);

const list = computed({
  get: () => {
    return categoryList[props.categoryIndex].list;
  },
});
const cursor = computed({
  get: () => {
    return categoryList[props.categoryIndex].cursor;
  },
});

const cardVisible = computed(() => {
  return (index) => index >= cursor.value - 1 && index < cursor.value + 3;
});

const startX = ref(0);
const startY = ref(0);
const moveX = ref(0);
const moveY = ref(0);
const endX = ref(0);
const endY = ref(0);
const disX = ref(0);
const disY = ref(0);
const direction = ref(null);

const flycard_container = ref(null);
const setFlycardContainer = (el) => {
  flycard_container.value = el;
};
const curCardDom = computed(() => {
  return flycard_container.value.querySelectorAll(".card")[cursor.value];
});
const prevCardDom = computed(() => {
  return cursor.value
    ? flycard_container.value.querySelectorAll(".card")[cursor.value - 1]
    : null;
});

const cardOnTouchstart = (e) => {
  if (direction.value) {
    direction.value = null;
  }
  startX.value = e.touches[0].clientX;
  startY.value = e.touches[0].clientY;
};
const cardOnTouchmove = (e) => {
  moveY.value = e.touches[0].clientY;
  moveX.value = e.touches[0].clientX;
  disY.value = startY.value - moveY.value;
  disX.value = startX.value - moveX.value;

  if (Math.abs(disY.value) > Math.abs(disX.value)) {
    if (!direction.value) {
      direction.value = disY.value > 0 ? "next" : "prev";
    }
    // 纵向滑动

    if (
      disY.value > 0 &&
      cursor.value < list.value.length - 1 &&
      direction.value === "next"
    ) {
      // 手指向上划
      curCardDom.value.style.transitionDuration = `0s`;
      curCardDom.value.style.transform = `scale(${
        1 - (Math.abs(disY.value) / window.innerHeight) * 0.08
      }) translateY(${-disY.value}px)`;

      curCardDom.value.style.opacity = 1 - Math.abs(disY.value) / window.innerHeight;
    } else if (disY.value <= 0 && cursor.value > 0 && direction.value === "prev") {
      // 手指向下划
      let el = prevCardDom.value;
      el.style.transitionDuration = `0s`;
      el.style.zIndex = `11`;
      el.style.transform = `scale(1) translateY(${
        -disY.value * 1.1 - el.offsetHeight
      }px)`;

      el.style.opacity = Math.abs(disY.value) / window.innerHeight + 0.8;
    }
  }
};
const cardOnTouchend = (e) => {
  endY.value = e.changedTouches[0].clientY;
  endX.value = e.changedTouches[0].clientX;
  disY.value = startY.value - endY.value;
  disX.value = startX.value - endX.value;

  if (Math.abs(disY.value) < curCardDom.value.offsetHeight * 0.1) {
    // 达不到翻页距离

    if (disY.value <= 0 && cursor.value > 0 && direction.value === "prev") {
      let el = prevCardDom.value;
      el.style.cssText = ``;
    } else if (
      disY.value > 0 &&
      cursor.value < list.value.length - 1 &&
      direction.value === "next"
    ) {
      curCardDom.value.style.transform = `translateY(0px)`;
      curCardDom.value.style.transitionDuration = `0.3s`;
      curCardDom.value.style.opacity = 1;
    } else {
      if (direction.value == "next") {
        if (cursor.value < list.value.length - 1) {
          curCardDom.value.style.transform = `translateY(0px)`;
          curCardDom.value.style.transitionDuration = `0.3s`;
          curCardDom.value.style.opacity = 1;
        }
      } else {
        if (cursor.value > 0) {
          let el = prevCardDom.value;
          el.style.cssText = ``;
        }
      }
    }
  } else {
    if (disY.value <= 0 && cursor.value > 0 && direction.value === "prev") {
      let el = prevCardDom.value;
      el.style.cssText = ``;
      categoryList[props.categoryIndex].cursor--;
    } else if (
      disY.value > 0 &&
      cursor.value < list.value.length - 1 &&
      direction.value === "next"
    ) {
      curCardDom.value.style.cssText = ``;
      categoryList[props.categoryIndex].cursor++;
    } else {
      if (direction.value == "next") {
        if (cursor.value < list.value.length - 1) {
          curCardDom.value.style.cssText = ``;
          categoryList[props.categoryIndex].cursor++;
        }
      } else {
        if (cursor.value > 0) {
          let el = prevCardDom.value;
          el.style.cssText = ``;
          categoryList[props.categoryIndex].cursor--;
        }
      }
    }
  }
};

const cardOnClick = (item) => {
  if (checkAppUserAgent()) {
    item["mediaId"] = curCategory.value["id"];
    let param = {
      news: item,
    };
    param = JSON.stringify(param);
    console.log(param);
    jsbridge("openAppArticleDetail", param);
  } else {
    window.open(item.rawUrl);
  }
};

const playerStatusBtnOnClick = (oldStatus) => {
  togglePlayerStatus(curFlycard.value, oldStatus);
};

const posterHeight = ref(((610 / 750) * window.innerWidth * 9) / 16);
</script>

<template>
  <div class="flycard">
    <div class="card-container" :ref="setFlycardContainer">
      <div class="card card-default" v-if="!list.length"></div>

      <div
        class="card"
        v-for="(item, index) in list"
        :key="index"
        :class="[
          'card-active-' + (index - cursor),
          cardVisible(index) ? 'card-active' : '',
          'c' + index,
        ]"
        @touchstart="cardOnTouchstart"
        @touchmove="cardOnTouchmove"
        @touchend="cardOnTouchend"
        @click="cardOnClick(item)"
      >
        <div class="card-content" v-if="cardVisible(index)">
          <van-image
            class="card-poster"
            :height="posterHeight"
            fit="cover"
            lazy-load
            :src="item.imgurl?item.imgurl: require('../assets/flycard-btu.jpg')"
            v-if="item.type != '6'"
          >
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>

          <video
            class="card-poster"
            id="card-video"
            controls
            playsinline
            webkit-playsinline
            x5-video-player-type="true"
            x5-video-orientation="portraint"
            v-if="item.type == '6'"
            :poster="item.imgurl"
            :src="item.videoUrl"
          ></video>

          <div class="card-title">
            {{ item.title }}
          </div>
          <div class="card-outline">
            {{ item.outline }}
          </div>

          <div class="card-tip">
            <div class="card-tip-left">上滑看下条</div>
            <div class="card-tip-right">点击查看详情</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@keyframes downup {
  0% {
    transform: translateY(-4px);
  }

  100% {
    transform: translateY(4px);
  }
}

.flycard {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  padding: 110px 0 calc($--tabbar-height + $--tabbar-space * 2);
  text-align: justify;
  text-align-last: left;

  .card-container {
    width: 100%;
    height: 100%;
    position: relative;

    .card {
      width: 610px;
      height: calc(100% - ($--tabbar-height + $--tabbar-space * 0.5));
      position: absolute;
      top: 90px;
      left: calc((100% - 610px) / 2);
      background: #fff;
      border-radius: 20px;
      opacity: 0;
      transform: scale(0.84) translateY(13.8%);
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .card-content {
        position: relative;
        height: 100%;
        text-align: left;
        text-align-last: start;
        .card-poster {
          width: 100%;
          vertical-align: bottom;
          object-fit: cover;
        }
        .card-title {
          margin: 36px 36px 32px;
          font-size: 40px;
          font-weight: bold;
          @include line(2);
        }
        .card-outline {
          margin: 0 36px;
          font-size: 32px;
          @include line(2);
        }
        .card-tip {
          position: absolute;
          width: 100%;
          left: 0;
          bottom: 0;
          padding: 36px;
          display: flex;
          justify-content: space-between;
          font-size: 28px;

          .card-tip-left {
            background: url("../assets/jt.png") no-repeat center left / auto 28px;
            color: #999;
            padding-left: 42px;
            animation: downup 1.3s ease-in-out 0.5s infinite alternate none;
          }
          .card-tip-right {
            color: $--theme-color;
          }
        }
      }

      &.card-default {
        opacity: 1;
        box-shadow: 0 5px 23px 11px rgba($color: rgb(0, 0, 0), $alpha: 0.13);
        transition: transform ease;
        transition-duration: 0.3s;
        transform: scale(1) translateY(0);
        z-index: 13;
        background: url("../assets/card_bg.png") #fff no-repeat center / contain;
      }
      &.card-active {
        opacity: 1;
        box-shadow: 0 5px 23px 11px rgba($color: rgb(0, 0, 0), $alpha: 0.13);
        transition: transform ease;
        transition-duration: 0.3s;
      }
      &.card-active--2 {
        opacity: 0.8;
        transform: scale(0.92) translateY(-100vh);
        z-index: 11;
      }
      &.card-active--1 {
        opacity: 0.8;
        transform: scale(0.92) translateY(-100vh);
        z-index: 11;
      }
      &.card-active-0 {
        opacity: 1;
        transform: scale(1) translateY(0);
        z-index: 10;
        transition: transform ease;
        transition-duration: 0.3s;
      }
      &.card-active-1 {
        opacity: 0.9;
        transform: scale(0.92) translateY(6.4%);
        z-index: 9;
      }
      &.card-active-2 {
        opacity: 0.8;
        transform: scale(0.84) translateY(13.8%);
        z-index: 8;
      }
    }
  }
}
</style>
